import L from "leaflet";

export const VenueIconWarning = L.icon({
  iconUrl: require("../../../../assets/location_warning.png"),
  iconSize: [38, 53]
});
